export default __webpack_public_path__ + "static/media/handphone.f54d074f.webp";